import * as Actions from './actions/actions'
import watch from 'redux-watch'
import { allowNav, deviceAllowsAutoNav } from '../../../util/dnn'
import { sendRequest } from '../../lib-alme-request/src/lib-alme-request';

export default class AutoNavWatcher {
    constructor(settings) {
        this._settings = settings;
    }

    initialize(store) {
        this._store = store;

        let autoNavWatchLocations = this._settings.stateLocations.AutoNav.watches;

        autoNavWatchLocations.forEach((loc) => {
            let watcher = watch(this._store.getState, loc);
            this._store.subscribe(watcher((newVal, oldVal, objectPath) => {
                this.handleAutoNav(newVal, oldVal, objectPath);
            }));
        });
    }

    handleAutoNav(newVal, oldVal, objectPath) {
        if (!this.doesHandle(newVal)) {
            return;
        }

        // Bind AutoNavWatcher instance
        const navigate = this.navigate.bind(this);
        // Wait for reportNav, then navigate on resolve/reject
        const navWithParams = () => { 
            navigate(newVal.UrlAddress, newVal.AutoNavigationType);
        };

        if(newVal.AutoNavigationType.toLowerCase() !== "none"){
            this.reportNav(newVal.UrlAddress).then(navWithParams, navWithParams); 
        }
    }

    reportNav(url) {
        const input = {
            eventName: 'AutoNav',
            eventValue: url,
            messageType: this._settings.messageConstants.reportingEventRequest,
        };
        return sendRequest(input);
    }

    navigate(url, navType) {
        let stateLocation = this._settings.stateLocations.AutoNav.isNavigating;
        let autoNavTypes = this._settings.navConstants.autoNavTypes;

        switch(navType) {
            case autoNavTypes.none:
                return;

            case autoNavTypes.mainPage:
                this._store.dispatch(Actions.navigatePage(url, navType, stateLocation));
                if (window && window.location && allowNav(window.location, this._settings)) {
                    this.changeWindowHref(url);
                }
            break;

            case autoNavTypes.popup:
                this._store.dispatch(Actions.navigatePage(url, navType, stateLocation));
                if (window) {
                    this.openNewWindow(url);
                }
            break;
        }
    }

    changeWindowHref(url) {
        window.location.href = url;
    }

    openNewWindow(url) {
        window.open(url, '_blank');
    }

    doesHandle(navUrl) {
        if(navUrl && navUrl.AutoNavigationType && navUrl.UrlAddress && deviceAllowsAutoNav(this._settings, this._store))
            return true;
        return false;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/auto-nav-url/src/autonav-watcher.js